import { Button } from "reactstrap";
import { connect } from "react-redux";
import "./Button.css";

const SyncMissingInfoButton = ({ onClick, badgeCount = 0, className = "" }) => {
  return (
    <Button
      className={`bomButtons linkBtn syncMissingInfoBtn ${className}`.trim()}
      onClick={onClick}
    >
      <i className="fa fa-refresh icon" aria-hidden="true" />
      <div className="text">
        Sync Missing Info
        {badgeCount > 0 && (
          <span className="badge badge-danger bomIssuesBadge">
            {badgeCount}
          </span>
        )}
      </div>
    </Button>
  );
};

const mapStateToProps = (state) => ({ user: state.user });

export default connect(mapStateToProps, {})(SyncMissingInfoButton);
